module.exports = __webpack_public_path__ + "img/aygaz-step-into-the-future-07.06ee7c4b.jpg";